import { useQuery } from '@tanstack/react-query';

import ReservationService from '~/services/ReservationService';

import { roomRateAvailabilityQueryKeys } from './roomRateAvailabilityQueryKeys';

export function useGetRoomTypeCapacities(
  propertyId: string | undefined,
  roomTypeId: string | undefined,
  roomRateId: string | undefined,
) {
  return useQuery<Array<{ id: string; is_dynamic: boolean; [key: string]: unknown }>>({
    queryKey: roomRateAvailabilityQueryKeys.capacities(propertyId ?? '', roomTypeId ?? '', roomRateId ?? ''),
    queryFn: async () =>
      (await ReservationService.getRoomTypeCapacities(propertyId, roomTypeId, roomRateId)).result?.capacities ?? [],
    enabled: !!propertyId && !!roomTypeId && !!roomRateId,
  });
}
